import { useFormContext } from "react-hook-form";

import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { updateLocationImageCache } from "modules/LocationOverviewDashboard/components/General/components";
import { ApiInstance } from "utils/Api";

import type { LocationDetailFormPayload } from "modules/LocationOverviewDashboard/hooks";

type UploadCompanyStampPayload = {
  path: string;
  file: File;
};

export const useUploadCompanyStampMutation = () => {
  const { setValue } = useFormContext<LocationDetailFormPayload>();

  return useTypedMutation({
    mutationFn: async ({ path, file }: UploadCompanyStampPayload) => {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("path", path);

      return (await ApiInstance.post("/locations/upload/company_stamp", fd, ENV.dealerBaseURL)).data.url;
    },
    onSuccess: (_, companyStamp) => {
      updateLocationImageCache("company_stamp", companyStamp);
      setValue("company_stamp", companyStamp);
    }
  });
};
